module.exports = __webpack_public_path__ + "img/slide-2.9e4d713f.png";